import markPic from "@/public/images/artists/mark.png";
import { Artist } from "@/types/types";

export const mark = {
  id: "101",
  name: "Mark",
  image: markPic,
  description: `Meet Mark, the AI singer whose electrifying voice effortlessly navigates the realms of Pop and EDM, captivating audiences with a unique blend of airy vocals that soar across a wide range. With a seamless fusion of genres, Mark delivers a mesmerizing auditory experience, pushing the boundaries of artificial intelligence in the realm of music.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmark-preview.mp3",
  meta: {
    free: true,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Airy"],
      secondary: ["Singer", "Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 48,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
